import { WorkflowConfig } from '@/app/workflows/actions/interfaces';

export const getMeshResolution = (config: WorkflowConfig) => {
  if (typeof config.limits?.faces?.count === 'number') {
    return config.limits.faces.count + '';
  }

  return `${config.limits?.faces?.percentage ?? 0}%`;
};
